import { render } from "./MyCourseCardsComponent.vue?vue&type=template&id=37621f16&scoped=true"
import script from "./MyCourseCardsComponent.vue?vue&type=script&lang=js"
export * from "./MyCourseCardsComponent.vue?vue&type=script&lang=js"

import "./MyCourseCardsComponent.vue?vue&type=style&index=0&id=37621f16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37621f16"]])

export default __exports__